import { IFormatObjectEditable } from "..";
import { IFormatAlert } from "../IFormatAlert";
import { ObjectAlert } from "../alerts";
import { IObjectValidator } from "../IObjectValidator";
import { ComboObjectEditor } from "../objectEditors";

export class ComboObjectValidator implements IObjectValidator {
  public validate(object: IFormatObjectEditable): IFormatAlert[] {
    const alerts: ObjectAlert[] = [];
    if (object instanceof ComboObjectEditor) {
      const options = object.comboSelectBehavior().getValue().options;
      if (!options || options.length < 1) {
        alerts.push(new ObjectAlert(object, "リスト選択項目を追加してください。"));
      }
    }
    return alerts;
  }
}
